export default __webpack_public_path__ + "static/media/icon_arrow_left.cb4be89e.svg";